<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="row" *ngIf="userdata.userlevel == '15' && id == 1 " >
        <div class="col-md-12" style="margin-left: 5px">
          <div class="card">
            <div class="card-header bg-primary no-print" style="cursor: move">
                <h2 class="card-title">แบบบันทึกเป้าหมายและตัวถ่วง</h2> 
                <div class="card-tools">
                 
                  </div>
              </div>
              <div class="card-body">
                <form [formGroup]="Action">
                  <div class="input-group mb-3">
                    <span class="input-group-text" >เลือกงวด</span>
                    <select  formControlName="selettime" class="form-select" (change)="LoadSuplist();">
                      <option *ngFor="let item of selecttime" [ngValue]="item.set">{{item.time}}</option>
                    </select>
                    <span class="input-group-text" >เลือกนักส่งเสริม</span>
                    <select  formControlName="supcode" class="form-select" (change)="LoadSupdata();">
                      <option *ngFor="let item of suplist" [ngValue]="[item.Supcode,item.Supzone]">{{item.Supcode +'|'+ item.SUPNAME}}</option>
                    </select>
                  </div>
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th scope="col">ลำดับ</th>
                      <th scope="col">หัวข้อ</th>
                      <th scope="col">ตัวถ่วง</th>
                      <th scope="col">เป้าหมาย</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="2" class="text-bold table-secondary">1.ยุทธศาสตร์การขยายพื้นที่ </td>
                      <td>
                        <input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1tp.errors }" formControlName="m1tp">
                        
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>พื้นที่ปลายฝน</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t1tp.errors }"  formControlName="m1t1tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t1tg.errors }"  formControlName="m1t1tg"></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>อ้อยตอ</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t2tp.errors }"  formControlName="m1t2tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t2tg.errors }"  formControlName="m1t2tg"></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>อ้อยต้นฝน</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t3tp.errors }"  formControlName="m1t3tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m1t3tg.errors }"  formControlName="m1t3tg"></td>
                    </tr>
                    <!-- ข้อ 2 -->
                    <tr>
                      <td colspan="2" class="text-bold table-secondary">2.ยุทธศาสตร์การขยายพื้นที่ </td>
                      <td>
                        <input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2tp.errors }"  formControlName="m2tp">
                      </td> 
                      <td></td>
                    </tr>
                    <tr>
                      <td>2.1</td>
                      <td>การระเบิดดาน</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t1tp.errors }"  formControlName="m2t1tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t1tg.errors }"  formControlName="m2t1tg"></td>
                    </tr>
                    <tr>
                      <td>2.2</td>
                      <td>พันธุ์อ้อย</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t2tp.errors }"  formControlName="m2t2tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t2tg.errors }"  formControlName="m2t2tg"></td>
                    </tr>
                    <tr>
                      <td>2.3</td>
                      <td>ระยะร่อง</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t3tp.errors }"  formControlName="m2t3tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t3tg.errors }"  formControlName="m2t3tg"></td>
                    </tr>
                    <tr>
                      <td>2.4</td>
                      <td>การระเบิดดาน</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t4tp.errors }"  formControlName="m2t4tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t4tg.errors }"  formControlName="m2t4tg"></td>
                    </tr>
                    <tr>
                      <td>2.5</td>
                      <td>ปุ๋ยเคมี 2</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t5tp.errors }"  formControlName="m2t5tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t5tg.errors }"  formControlName="m2t5tg"></td>
                    </tr>
                    <tr>
                      <td>2.6</td>
                      <td>ปุ๋ยเคมี 3</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t6tp.errors }"  formControlName="m2t6tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t6tg.errors }"  formControlName="m2t6tg"></td>
                    </tr>
                    <tr>
                      <td>2.7</td>
                      <td>การใส่อินทรีย์</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t7tp.errors }"  formControlName="m2t7tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t7tg.errors }"  formControlName="m2t7tg"></td>
                    </tr>
                    <tr>
                      <td>2.8</td>
                      <td>การใส่โดโลไมท์</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t8tp.errors }"  formControlName="m2t8tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t8tg.errors }"  formControlName="m2t8tg"></td>
                    </tr>
                    <tr>
                      <td>2.9</td>
                      <td>เปอร์เซนต์การงอก</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t9tp.errors }"  formControlName="m2t9tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t9tg.errors }"  formControlName="m2t9tg"></td>
                    </tr>
                    <tr>
                      <td>2.10</td>
                      <td>วัชพืช</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t10tp.errors }"  formControlName="m2t10tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t10tg.errors }"  formControlName="m2t10tg"></td>
                    </tr>
                    <tr>
                      <td>2.11</td>
                      <td>โรคและแมลง</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t11tp.errors }"  formControlName="m2t11tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t11tg.errors }"  formControlName="m2t11tg"></td>
                    </tr>
                    <tr>
                      <td>2.12</td>
                      <td>การพูนโคน</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t12tp.errors }"  formControlName="m2t12tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m2t12tg.errors }"  formControlName="m2t12tg"></td>
                    </tr>
    
                    <!-- ข้อ 3 -->
                    <tr>
                      <td colspan="2" class="text-bold table-secondary">3.ยุทธศาสตร์การพัฒนายกระดับชาวไร่มืออาชีพ </td>
                      <td>
                        <input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3tp.errors }"  formControlName="m3tp">
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>ข้อ</td>
                      <td>เรื่อง</td>
                      <td>ตัวถ่วง</td>
                      <td>เป้าหมาย</td>
                      <td>ผลงาน</td>

                    </tr>
                    <tr>
                      <td>3.1</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t1lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t1tp.errors }"  formControlName="m3t1tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t1tg.errors }"  formControlName="m3t1tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t1sc.errors }"  formControlName="m3t1sc"></td>

                    </tr>
                    <tr>
                      <td>3.2</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t2lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t2tp.errors }"  formControlName="m3t2tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t2tg.errors }"  formControlName="m3t2tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t2sc.errors }"  formControlName="m3t2sc"></td>

                    </tr>
                    <tr>
                      <td>3.3</td>
                     <td><input type="text"  class="form-control"  formControlName="m3t3lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t3tp.errors }"  formControlName="m3t3tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t3tg.errors }"  formControlName="m3t3tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t3sc.errors }"  formControlName="m3t3sc"></td>

                    </tr>
                    <tr>
                      <td>3.4</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t4lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t4tp.errors }"  formControlName="m3t4tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t4tg.errors }"  formControlName="m3t4tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t4sc.errors }"  formControlName="m3t4sc"></td>

                    </tr>
                    <tr>
                      <td>3.5</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t5lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t5tp.errors }"  formControlName="m3t5tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t5tg.errors }"  formControlName="m3t5tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t5sc.errors }"  formControlName="m3t5sc"></td>

                    </tr>
                    <tr>
                      <td>3.6</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t6lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t6tp.errors }"  formControlName="m3t6tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t6tg.errors }"  formControlName="m3t6tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t6sc.errors }"  formControlName="m3t6sc"></td>

                    </tr>
                    <tr>
                      <td>3.7</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t7lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t7tp.errors }"  formControlName="m3t7tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t7tg.errors }"  formControlName="m3t7tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t7sc.errors }"  formControlName="m3t7sc"></td>

                    </tr>
                    <tr>
                      <td>3.8</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t8lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t8tp.errors }"  formControlName="m3t8tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t8tg.errors }"  formControlName="m3t8tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t8sc.errors }"  formControlName="m3t8sc"></td>

                    </tr>
                    <tr>
                      <td>3.9</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t9lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t9tp.errors }"  formControlName="m3t9tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t9tg.errors }"  formControlName="m3t9tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t9sc.errors }"  formControlName="m3t9sc"></td>

                    </tr>
                    <tr>
                      <td>3.10</td>
                      <td><input type="text"  class="form-control"  formControlName="m3t10lb"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t10tp.errors }"  formControlName="m3t10tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t10tg.errors }"  formControlName="m3t10tg"></td>

                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m3t10sc.errors }"  formControlName="m3t10sc"></td>

                    </tr>

                    <!-- ข้อ 4 -->
                    <tr>
                      <td colspan="2" class="text-bold table-secondary">4.ยุทธศาสตร์ยกระดับศักยภาพระบบบริหาร </td>
                      <td>
                        <input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4tp.errors }"  formControlName="m4tp">
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="4" >4.1 เกรดชาวไร่</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>- เกรด A</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tpA.errors }"  formControlName="m4t1tpA"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tgA.errors }"  formControlName="m4t1tgA"></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>- เกรด B</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tpB.errors }"  formControlName="m4t1tpB"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tgB.errors }"  formControlName="m4t1tgB"></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>- เกรด C</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tpC.errors }"  formControlName="m4t1tpC"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t1tgC.errors }"  formControlName="m4t1tgC"></td>
                    </tr>
                    <tr>
                      <td colspan="2">4.2 การตรวจเยี่ยมชาวไร่</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t2tp.errors }"  formControlName="m4t2tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t2tg.errors }"  formControlName="m4t2tg"></td>
                    </tr>
                    <tr>
                      <td colspan="4" >4.3 สินเชื่อ</td>
                    </tr>
                    <tr>
                      <td>4.3.1</td>
                      <td> อ้อยปลูกใหม่</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t31tp.errors }"  formControlName="m4t31tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t31tg.errors }"  formControlName="m4t31tg"></td>
                    </tr>
                    <tr>
                      <td>4.3.2</td>
                      <td>แปลงที่จ่าย 6,000 บาท แต่ยังไม่ปลูก </td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t32tp.errors }"  formControlName="m4t32tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t32tg.errors }"  formControlName="m4t32tg"></td>
                    </tr>
                    <tr>
                      <td>4.3.3</td>
                      <td>แปลงที่จ่าย 6,000 บาท ทำกิจกรรมครบตามแผน (ระเบิดาน, อินทรีย์,โดโลไมท์)</td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t33tp.errors }"  formControlName="m4t33tp"></td>
                      <td><input type="text" (keypress)="numberOnly($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.m4t33tg.errors }"  formControlName="m4t33tg"></td>
                    </tr>
                    <tr>
                      <td colspan="3"> <button class="btn btn-primary" [disabled]="!Action.valid" (click)="SaveData();">บันทึกข้อมูล</button> </td>
                    </tr>
                  </tbody>
                </table>
                </form>
              </div>
          </div>
        </div>
        
        
      </div>

     <div class="row" *ngIf="id == 2 ">
       
       <div class="col-md-12">
         <div class="card">
           <div class="card-header no-print">
            <div   >
              <button style="float: left;" class="btn btn-primary no-print" (click)="goPrint();"> Print</button>
              <button style="float: right;" class="btn btn-primary no-print" (click)="ExportExcel();"> Download</button>
            </div>
           </div>
           <div class="card-body">

            <div class="input-group mb-3 no-print">
              <span class="input-group-text" >เลือกงวด</span>
              <select  [(ngModel)]="date"class="form-select" (change)="Loadbydate();">
                <option *ngFor="let item of selecttime" [ngValue]="item.set">{{item.time}}</option>
              </select>
            </div>
            <div class="row">
              <div class="col-12">
                <div>
                  <h2 class="text-center">รายงานสรุปคะแนน KPI นักส่งเสริม</h2>  
                  <h3 class="text-center">ประจำงวด {{lotedate}}</h3> 
                </div>
               
              </div>
            
            </div>
                  
             <table class="table" #table>
              <thead>
                <tr>
                  <th scope="col" class="text-center">ส่วน</th>
                  <th scope="col" class="text-center">เขต</th>
                  <th scope="col" class="text-center">รหัส</th>
                  <th scope="col">ชื่อ</th>
                  <th scope="col" class="text-center">ข้อ 1</th>
                  <th scope="col" class="text-center">ข้อ 2</th>
                  <th scope="col" class="text-center">ข้อ 3</th>
                  <th scope="col" class="text-center">ข้อ 4</th>
                  <th scope="col" class="text-center">ข้อ 5</th>
                  <th scope="col" class="text-center">ข้อ 6</th>
                  <th scope="col" class="text-center">รวม</th>
                </tr>
              </thead>
              <tbody >
                <tr *ngFor="let item of bydate">
                  <td class="text-center">{{item.Partcode}}</td>
                  <td class="text-center">{{item.Supzone}}</td>
                  <td class="text-center">{{item.Supcode}}</td>
                  <td>{{item.SUPNAME}}</td>
                  <td class="text-center">{{item.score1get | number}}</td>
                  <td class="text-center">{{item.score2get | number}}</td>
                  <td class="text-center">{{item.score3get | number}}</td>
                  <td class="text-center">{{item.score4get | number}}</td>
                  <td class="text-center">{{item.score5get | number}}</td>
                  <td class="text-center">{{item.score6get | number}}</td>
                  <td class="text-center">{{item.scoretotal | number}}</td>
                </tr>
              </tbody>
             </table>
           </div>
         </div>
       
       </div>
     </div> 
   
</div>
<app-footer></app-footer>